import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import parse from 'html-react-parser';
import sanitize from 'sanitize-html';
import { patchImageUrl } from '@culture/common-helpers/cultureUtils';

import { addTooltipToStyledContent } from 'components/StyledContent/addTooltipToStyledContent';
import Icon from 'components/Icon';
import { ImageFormatContext } from 'contexts/ImageFormatContext';
import LazyLoadImage from 'components/LazyLoad/Image';

import styles from './styles.module.scss';

const StyledContentQuote = ({ align, description, text, thumbnail }) => {
	const imageFormat = useContext(ImageFormatContext);
	const quoteCx = cx(
		styles.StyledContentQuote,
		styles[`StyledContentQuote_align_${align}`]
	);
	const parsedQuoteText = parse(sanitize(text), {
		replace: addTooltipToStyledContent
	});
	const parsedQuoteDescription = parse(sanitize(description), {
		replace: addTooltipToStyledContent
	});
	const imageSrc = patchImageUrl(thumbnail, { format: imageFormat });

	return (
		<div className={quoteCx}>
			{imageSrc && (
				<LazyLoadImage
					className={styles.StyledContentQuote__ImageWrapper}
					imageSrc={imageSrc}
					placeholder={<></>}
				>
					<img
						alt=""
						src={imageSrc}
						className={styles.StyledContentQuote__Image}
					/>
				</LazyLoadImage>
			)}
			<div className={styles.StyledContentQuote__Content}>
				<Icon icon="quoteStart" className={styles.StyledContentQuote__Icon} />
				<div className={styles.StyledContentQuote__Text}>{parsedQuoteText}</div>
				{description && (
					<div className={styles.StyledContentQuote__Description}>
						{parsedQuoteDescription}
					</div>
				)}
			</div>
		</div>
	);
};

StyledContentQuote.propTypes = {
	text: PropTypes.string.isRequired,
	align: PropTypes.oneOf(['left', 'right']),
	description: PropTypes.string,
	thumbnail: PropTypes.string
};

export default StyledContentQuote;
